import { gql } from '@apollo/client';

const sendMailContactExecutive = gql`
  mutation sendMailContactExecutive($input: ContactExecutiveInput!) {
    sendMailContactExecutive(input: $input) {
      statusCode
      body {
        data
        error
      }
    }
  }
`;

export default sendMailContactExecutive;